import React, { useState } from "react";

export const SecretShopperReport = ({ template, onSubmit, readOnly = false, externalData, onExternalChange }) => {
 const [internalData, setInternalData] = useState({});

 // Используем внешнее состояние если передано (предотвращает очищение при загрузке файлов)
 const reportData = externalData !== undefined ? externalData : internalData;
 const setReportData = (val) => {
 if (onExternalChange) onExternalChange(typeof val === 'function' ? val(reportData) : val);
 else setInternalData(val);
 };

 const handleSubmit = (e) => {
 e.preventDefault();
 onSubmit(reportData);
 };

 return (
 <div className="bg-gray-50 p-4 rounded-lg">
 <h4 className="text-sm font-medium text-gray-700 mb-4">Отчет тайного покупателя</h4>
 <form id="secret-shopper-form" onSubmit={handleSubmit} className="space-y-4">
 {template.required_fields.map((field) => (
 <div key={field.name}>
 <label className="block text-sm font-medium text-gray-700 mb-1">
 {field.label}
 </label>
 {field.type === 'text' && (
 <textarea
 name={field.name}
 value={reportData[field.name] || ''}
 onChange={(e) =>setReportData({...reportData, [field.name]: e.target.value})}
 disabled={readOnly}
 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
 rows="3"
 />
 )}
 {field.type === 'rating' && (
 <select
 name={field.name}
 value={reportData[field.name] || ''}
 onChange={(e) =>setReportData({...reportData, [field.name]: e.target.value})}
 disabled={readOnly}
 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
 >
 <option value="">Выберите оценку</option>
 {[1,2,3,4,5].map(rating => (
 <option key={rating} value={rating}>{rating} звезд</option>
 ))}
 </select>
 )}
 {field.type === 'boolean' && (
 <div className="flex items-center space-x-2">
 <input
 type="checkbox"
 name={field.name}
 checked={reportData[field.name] || false}
 onChange={(e) =>setReportData({...reportData, [field.name]: e.target.checked})}
 disabled={readOnly}
 className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
 />
 <span className="text-sm text-gray-700">Да</span>
 </div>
 )}
 </div>
 ))}
 {!readOnly && (
 <div className="mt-4 p-3 bg-blue-50 rounded-md">
 <p className="text-sm text-blue-800">
 <strong>Инструкция:</strong>Сначала загрузите фото/видео в блоке "Загрузка результатов" выше, затем заполните все поля отчёта и нажмите кнопку "Завершить задание с отчётом" внизу страницы
 </p>
 </div>
 )}
 </form>
 </div>
 );
};
